'use strict';

import type { App } from '../Entities/App';
import { EntityCollection } from './EntityCollection';

export class AppCollection extends EntityCollection<App> {}
